<template>
  <div class="filter-collection critical-component-clear" :class="{ 'secondary-collection': secondaryCollection }">
    <div class="page-section">
      <collection-hero :description="liquid.description" :image="liquid.image" :video="liquid.video"
        :template="template" :title="liquid.title"  :collectiondescription="liquid.collectiondescription"/>

        <div v-if="enablebanner && isMobile" class="collection-hero__media">
          <div class="filter-collection__mobbanner">
              <div v-if="mobilebannertext != '' " class="filter-collection__mobilebanner_withtext"/>
            
            <div v-else class="filter-collection__mobilebanner"/>
            
          </div>
          <div class="filter-collection__mobiletext" >
            <p class="text-heading-2xs" v-text="mobilebannertext" />
          </div>
         </div>
      <filter-grid :current-result-count="currentResultCount" :banner="banner" :banner-position="bannerPosition"
        :filters="liquid.filters" :grid-class="gridClass" :grid-size="gridSize" :selectedtags="selectedTags"
        :liquid="liquid" :product-list="productList" :search-more="searchMore"
        :secondary-collection="secondaryCollection" :total-results-count="totalResultsCount" :template="template"
        :collectionlist="collectionlist" @update-search-sort="updateSort" @load-more-products="loadMoreProducts"
        @update-filters="updateFilters" @all-cards-loaded="handleAllCardsLoaded" :comingsoon="comingsoon" :cbanner="cbanner" :ctext="ctext"/>


    </div>
  </div>
</template>

<script>
import FilterGrid from '~async/filter-grid/filter-grid'
import CollectionHero from '~async/collection-hero/collection-hero'

import { initKlevu, sanitizedCollectionObject } from '~/apis/klevu'
import {
  applyFilterWithManager,
  categoryMerchandising,
  FilterManager,
  KlevuDomEvents,
  KlevuFetch,
  KlevuSearchSorting,
  listFilters,
  sendMerchandisingViewEvent,
  // eslint-disable-next-line import/no-unresolved
} from '@klevu/core'
import { mapState } from 'vuex'
import { mapActions } from 'vuex'

/**
 * Vue: Main collection (main-collection)
 * -----------------------------------------------------------------------------
 * Main collection page component.
 * - Static section.
 *
 */
export default {
  name: 'FilterCollection',
  components: {
    FilterGrid,
    CollectionHero,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        blockLength: 0,
        title: '',
        description: '',
        products: [],
        pageInfo: {},

      }),
    },
    gridClass: {
      type: String,
      default: '',
    },
    cbanner: {
      type: Object,
      default: '',
    },
    ctext: {
      type: String,
      default: '',
    },
    gridSize: {
      type: String,
      default: '',
    },
    mobilebannertext:{
      type: String,
      default: '',
    },
    comingsoon :{
      type: Boolean,
      default: false,
    },
    klevu: {
      type: Object,
      default: () => ({}),
    },
    secondaryCollection: {
      type: Boolean,
      default: false,
    },
    template: {
      type: String,
      default: '',
    },
    banner: {
      type: String,
      default: null,
    },
    bannerPosition: {
      type: [Number, String],
      default: 1,
    },
    collectionlist: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    const { currency } = window.cnvs.store

    return {
      currency,
      currentFilters: [],
      currentResultCount: null,
      filterManager: new FilterManager(),
      initialResults: null,
      selectedTags: null,
      klevuFetched: false,
      productClickEvent: null,
      productList: [],
      newproductList: [],
      searchMore: false,
      sort: KlevuSearchSorting.Relevance,
      sortOptions: KlevuSearchSorting || [],
      totalResultsCount: null,
    }
  },
  computed: {

/**
 * Map Vuex state.
 */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),


  },
  async mounted() {
    
    //await initKlevu(this.klevu.url, this.klevu.key)
    this.productList = [...this.liquid.allProducts.filter(product => {
        if (product.variants.length === 1) {
          const variant = product.variants[0];
          const country = cnvs?.store?.country?.toLowerCase();
          const hiddenCountries = variant.hide_variant?.toLowerCase().split(",") || [];
          return !hiddenCountries.includes(country); // hide if country is listed
        }else{
          return product
        }
      })]
    this.totalResultsCount = this.productList.length
    this.currentResultCount = this.productList.length
    this.searchMore = false
    this.currentFilters = this.liquid.filters
    //this.setKlevuEventListeners()
    this.setSortOptions()
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      setFilters: 'search/setFilters',
      setState: 'components/setState',
    }),


    /**
     * Update collection object to match specific markets and languages
     * @param {Object} collection - collection object from Klevu
     */
    updateCollectionObject(collection) {
      const productList = sanitizedCollectionObject(collection)
      const { products } = this.liquid
      const { baseCurrency, currency, language } = window.cnvs.store

      if (baseCurrency === currency && language.includes('en')) {
        return productList
      }

      const updatedList = productList.map((product) => {
        const matchingProduct = products.find(
          (item) => item.selectedOrFirstAvailableVariant.id === Number(product.id),
        )
        const matchingPrices =
          product.compareAtPrice?.amount === matchingProduct?.compareAtPrice?.amount &&
          product.price.amount === matchingProduct?.price?.amount

        if (matchingProduct && !matchingPrices) {
          product.compareAtPrice.amount = matchingProduct.compareAtPrice.amount || 0
          product.price.amount = matchingProduct.price.amount
        }

        product.title = language.includes('en') ? product.title : matchingProduct.title

        return product
      })

      return updatedList
    },


    updateSort(sorted) {
      if(sorted  === 'PRICE_ASC'){
       let products = [...this.productList]
       products.sort((a, b) => a.price.amount- b.price.amount);
        this.productList = products
      }
      if(sorted  ==='PRICE_DESC'){
       let products = [...this.productList]
       products.sort((a, b) => b.price.amount- a.price.amount);
        this.productList = products
      }
      if(sorted  ==='NAME_ASC'){
       let products = [...this.productList]
       products.sort((a, b) => a.title.localeCompare(b.title));
        this.productList = products
      }
      if(sorted  ==='NAME_DESC'){
       let products = [...this.productList]
       products.sort((a, b) => b.title.localeCompare(a.title));
        this.productList = products
      }
      if(sorted  === 'RELEVANCE'){
        let products =  [...this.allProducts]
        this.productList = products
      }
    },

    async loadMoreProducts() {
      let listProducts = this.newproductList;
      let newProducts = [];


      if (this.totalResultsCount > this.currentResultCount) {

        newProducts = listProducts.slice(this.currentResultCount, this.currentResultCount + this.liquid.productsPerPage);

        this.productList = [...this.productList, ...newProducts];

        this.currentResultCount += newProducts.length;

        this.searchMore = true;
        if (this.productList.length == this.totalResultsCount) {
          this.searchMore = false;
        }

      } else {
        this.searchMore = false;
      }
    },

    captureClickedProduct(product) {
      this.productClickEvent(product.id, this.liquid.title)
      window.location = product.url
    },



    async updateFilters(key, value) {


      let newproducts;
      let productCount;
      let dataval;

      let allProducts = this.liquid.allProducts.filter(product => {
        if (product.variants.length === 1) {
          const variant = product.variants[0];
          const country = cnvs?.store?.country?.toLowerCase();
          const hiddenCountries = variant.hide_variant?.toLowerCase().split(",") || [];
          return !hiddenCountries.includes(country); // hide if country is listed
        }else{
          return product
        }
      })
      let filterButton = document.getElementById('btn-' + key + '-' + value);
      if (filterButton.classList.contains('selected')) {
        filterButton.classList.remove('selected');
      } else {
        filterButton.classList.add('selected');
      }

      const decodeHtmlEntities = (text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        return doc.body.textContent || "";
      }
      const filterProducts = (products, tags, Ids) => {
       
        const filterByType = Ids.includes('filter.p.product_type');
        const filterByCompatible = Ids.includes('filter.p.m.custom.compatible_with');
        const filterbylength = Ids.includes('filter.v.option.choose blade length');

        // Helper function for HTML entities decoding
        const decodeHtmlEntities = (text) => {
          if (!text || typeof text !== 'string') return '';
          return text.replace(/&quot;/g, '"').replace(/&amp;/g, '&');
        };

        return products.filter(product => {
          let matchesType = true;
          let matchesCompatible = true;
          let matcheslength = true;
         
          // Type filtering
          if (filterByType) {
            matchesType = typeof product.type === 'string' &&
              tags.some(tag => decodeHtmlEntities(tag.toLowerCase().trim()) === decodeHtmlEntities(product.type.toLowerCase().trim()));
         
          }

          // Compatibility filtering
          if (filterByCompatible) {
            // Set default to false if we're filtering by compatibility
            matchesCompatible = false;

            // Check if product.compatible_with exists
            if (product.compatibility) {
              // If compatible_with is an array
              if (Array.isArray(product.compatibility)) {
              
                if (product.compatibility.length > 0) {
                  const compatibilityTags = product.compatibility
                    .filter(item => item) // Filter out any null/undefined values
                    .flatMap(compatible => typeof compatible === 'string' && compatible.includes('|') ?
                      compatible.split('|') : compatible);

                  matchesCompatible = compatibilityTags.some(tag => tags.includes(tag));
                
                }
              }
              // If compatible_with is a string
              else if (typeof product.compatibility === 'string') {
             
                const compatibilityTags = product.compatibility.includes('|') ?
                  product.compatibility.split('|') : [product.compatibility];

                matchesCompatible = compatibilityTags.some(tag => tags.includes(tag));
                
              }
              // For any other data type (number, etc.)
              else {
                // Convert to string for comparison
                matchesCompatible = tags.includes(String(product.compatibility));
              }
            } else {
              //console.log('Product has no compatible_with property');
            }
          }

          // Length filtering
          if (filterbylength && Array.isArray(product.variants) && Array.isArray(tags)) {
            const matches = product.variants.filter(variant =>
              variant.title && tags.some(tag =>
                decodeHtmlEntities(tag.toLowerCase().trim()) === decodeHtmlEntities(variant.title.toLowerCase().trim())
              )
            );

            matcheslength = matches.length > 0;
          }

          return matchesType && matchesCompatible && matcheslength;
        });
      };

      let checkboxes = document.getElementsByClassName('filter-value__btn');
      let selectedTags = [];
      let selectedIds = [];

      for (let x = 0; x < checkboxes.length; x++) {
        if (checkboxes[x].classList.contains('selected')) {
         
          selectedTags.push(checkboxes[x].value);
          let checkboxId = checkboxes[x].id;
          let parts = checkboxId.split('-');

          if (parts.length >= 3) {
            let key = parts.slice(1, -1).join('-');
            selectedIds.push(key);
          }

        }
      }

      if (selectedTags.length > 0) {

        this.selectedTags = selectedTags;
        let listProducts = allProducts;
        newproducts = filterProducts(listProducts, selectedTags, selectedIds);
        
        this.totalResultsCount = newproducts.length
        this.currentResultCount = newproducts.length
        this.productList = newproducts;
        this.newproductList = newproducts
        if (this.totalResultsCount > this.currentResultCount) {
          this.searchMore = true;
        }
      } else {
        this.selectedTags = 0;
        this.totalResultsCount = allProducts.length
        this.currentResultCount = allProducts.length
        this.productList = [...allProducts];
        if (this.totalResultsCount > this.currentResultCount) {
          this.searchMore = true;
        }
      }
    },

    //setKlevuEventListeners() {
    //  document.addEventListener(KlevuDomEvents.FilterSelectionUpdate, this.fetchProducts)
    //},

    setSortOptions() {
      const selectedOptions = ['RELEVANCE', 'NAME_ASC', 'NAME_DESC', 'PRICE_DESC', 'PRICE_ASC']
      this.sortOptions = selectedOptions
    },

    handleAllCardsLoaded() {
      this.setState({ handle: 'filter-collection-cards-loaded', state: 'active' })
    },
  },
}
</script>

<style lang="scss">
@import '~async/product-card/product-card';
@import '@/components/pagination';
@import './filter-collection';
</style>
